import React, { memo } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import styles from './Header.module.scss'
import { ReactComponent as ClearIcon } from '../../assets/clear-icon.svg'

const OrdersHeader = ({ currentFilter, currentSearch, onFilter, onClearSearch, onSearch, className }) => {
  const classNames = cn(styles.ordersHeader, className)

  return (
    <div className={classNames}>

      <div className={styles.fieldContainer}>
        <label htmlFor='orderSearch'>Search</label>
        <input id='orderSearch' value={currentSearch} onChange={(e) => onSearch(e.target.value)} />
        {currentSearch && (
          <div className={styles.clearIconContainer} onClick={onClearSearch}>
            <ClearIcon className={styles.clearIcon} />
          </div>
        )}
      </div>

      {/*
        <div className={styles.fieldContainer}>
          <label htmlFor='filterSelector'>By Status</label>
          <select id='filterSelector' value={currentFilter} onChange={(e) => onFilter(e.target.value)} >
            <option value='all'>All</option>
            <option value='offline'>Offline</option>
            <option value='failure'>Failures</option>
            <option value='success'>Success</option>
          </select>
        </div>
      */}
    </div>
  )
}

OrdersHeader.defaultTypes = {
  currentFilter: '',
  currentSearch: '',
}

OrdersHeader.propTypes = {
  currentFilter: PropTypes.string,
  currentSearch: PropTypes.string,
  onClearSearch: PropTypes.func,
  onFilter: PropTypes.func,
  onSearch: PropTypes.func,
}

export default memo(OrdersHeader)
